import { useQuery } from "react-query";
import axios from "infra/http";
import { ProcuracaoDetalhe } from "../../typings/procuracao";

function useProcuracao({
  idProcuracao,
  idVotacao,
}: {
  idProcuracao: string;
  idVotacao: string;
}) {
  return useQuery(
    [`/v1/votacao/${idVotacao}/procuracao/${idProcuracao}`],
    async () => {
      const res = await axios.get<ProcuracaoDetalhe>(
        `/v1/votacao/${idVotacao}/procuracao/${idProcuracao}`
      );

      return res.data;
    }
  );
}

export default useProcuracao;
